// export type SerializationType = 'string' | 'objectORnumberORboolean';
//
// /**
//  * NOTES:
//  * use "string" ONLY for strings
//  * use "objectORnumberORboolean" for the rest
//  *
//  * @param e
//  * @param type
//  */
// export const queryStateParser = (
//   e: string | null | undefined,
//   type: SerializationType = 'objectORnumberORboolean',
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
// ): any => {
//   if (e === null || e === undefined) return type === 'objectORnumberORboolean' ? {} : '';
//   return type === 'objectORnumberORboolean' ? JSON.parse(decodeURIComponent(e)) : decodeURIComponent(e);
// };
//
// /**
//  * NOTES:
//  * use "string" ONLY for strings
//  * use "objectORnumberORboolean" for the rest
//  * @param e
//  * @param type
//  */
// // eslint-disable-next-line @typescript-eslint/no-explicit-any
// export const queryStateSerializer = (e: any, type: SerializationType = 'objectORnumberORboolean'): string =>
//   encodeURIComponent(type === 'objectORnumberORboolean' ? JSON.stringify(e) : e);
export type SerializationType = 'string' | 'objectORnumberORboolean';
type SerializableValue = string | number | boolean | object | null | undefined;

/**
 * Parses a URL query parameter value based on the specified type
 * @param value - The encoded query parameter value
 * @param type - The type of value to parse ('string' or 'objectORnumberORboolean')
 * @returns The parsed value, otherwise the default value
 * @throws {SyntaxError} If JSON parsing fails
 * @throws {URIError} If decoding fails
 */
export const queryStateParser = <T extends SerializableValue>(
  value: string | null | undefined,
  type: SerializationType = 'objectORnumberORboolean',
): T => {
  // handle null/undefined cases
  if (value == null) {
    return (type === 'objectORnumberORboolean' ? {} : '') as T;
  }

  const decoded = decodeURIComponent(value);

  if (type === 'string') {
    return decoded as T;
  }

  // for objectORnumberORboolean type, parse JSON directly
  return JSON.parse(decoded) as T;
};

/**
 * Serializes a value for use in URL query parameters
 * @param value - The value to serialize
 * @param type - The type of serialization to perform
 * @returns The serialized and encoded string
 */
export const queryStateSerializer = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any,
  type: SerializationType = 'objectORnumberORboolean',
): string => {
  // if (value == null) {
  //   return encodeURIComponent(type === 'objectORnumberORboolean' ? '{}' : '');
  // }

  if (type === 'string') {
    return encodeURIComponent(String(value));
  }

  return encodeURIComponent(JSON.stringify(value));
};
